

































































































































import { Component, Mixins } from "vue-property-decorator";
import MyList from "@/mixins/list";
import Add from "./Add.vue";

@Component({
  components: {
    Add,
  },
})
export default class extends Mixins(MyList) {
  dispatchType = "message/getMessages";
  // dispatchTypeDelete: string = 'setting/delete'
  // deleteConfirmContent: string = '确认要删除该配置吗？'
  // page: number = 10
  // page_size: number = 10

  editData: any = {};

  columns: any[] = [
    // {
    //   title: '编号',
    //   dataIndex: 'id'
    // },
    {
      title: "通知类型",
      scopedSlots: { customRender: "msg_type" },
    },
    {
      title: "通知方式",
      scopedSlots: { customRender: "cate" },
    },
    {
      title: "通知内容",
      scopedSlots: { customRender: "content" },
    },
    {
      title: "创建时间",
      dataIndex: "created_time",
    },
    {
      title: "操作",
      width: 150,
      scopedSlots: { customRender: "action" },
    },
  ];

  // 操作搜索栏的展开和折叠
  isFlag = false;


  mounted() {
    // this.searchData.msg_types = [2, 3, 4, 5]
    this.loadData();
  }

  showEditModal1(id: number, record: any) {
    this.editId = id;
    this.editData = record;
    this.editModalVisible = true;
  }
}
